import styled, { css } from 'styled-components';

export const Button = styled.button`
  ${({
    theme, $version, $onlyFillSvg, disabled,
  }) => css`
  background-color: transparent;
  border: none;
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  padding: ${$version === 'v2' && '0'};

    &:hover {
      svg {
        fill: ${$version === 'v2' && $onlyFillSvg && theme.v1.color.action.hover};
      }

      svg path {
        stroke: ${$version === 'v2' && !$onlyFillSvg && theme.v1.color.action.hover};
      }
    }
  `};
`;
